import { defineComponent, h, openBlock, createElementBlock, normalizeClass, unref, createVNode } from 'vue';
import { ALIGN } from '@omnica/error';

const arraify = (value) => Array.isArray(value)
    ? [...value]
    : [value];
const render = (content) => arraify(typeof content === 'function'
    ? content(h)
    : content);

var script$1 = defineComponent({
    name: 'OmnicaVNodeContent',
    props: {
        /** Контент для отрисовки */
        content: {
            type: null,
            validator: () => true,
            required: true,
        },
    },
    setup: props => () => render(props.content),
});

script$1.__file = "packages/scaffolding/src/OmnicaVNodeContent.vue";

var script = /*#__PURE__*/ defineComponent({
    __name: 'UiError',
    props: {
        /** Тест, разметка ошибки */
        message: {
            type: null,
            required: true,
        },
        /** Определяет, по какому краю будет выровнен текст ошибки */
        align: {
            type: String,
            validator: (align) => Object.values(ALIGN).includes(align),
            default: ALIGN.LEFT,
        },
        /**
         * Определяет, будет ли текст ошибок обрезаться через многоточие или
         *  переноситься на следующую строку
         */
        ellipsis: {
            type: Boolean,
            default: false,
        },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (openBlock(), createElementBlock("div", {
                class: normalizeClass({
                    'omnica-error': true,
                    'omnica-error_ellipsis': __props.ellipsis,
                    'omnica-error_right': __props.align === unref(ALIGN).RIGHT,
                })
            }, [
                createVNode(unref(script$1), { content: __props.message }, null, 8 /* PROPS */, ["content"])
            ], 2 /* CLASS */));
        };
    }
});

script.__file = "packages/error/src/UiError.vue";

export { script as default };
